import React, {useState} from 'react';
import {useEffect} from 'react';

function ImagesInput({payload, setPayload}) {
    const [selectedLogo, setSelectedLogo] = useState(null);
    const [selectedCover, setSelectedCover] = useState(null);

    const fileInput = document.getElementById('square-image-input');
    const squareContainer = document.querySelector('.square');

    if (fileInput && squareContainer){
        fileInput.addEventListener('change', function(event) {
            const file = event.target.files[0];
            const reader = new FileReader();

            reader.onload = function(e) {
                squareContainer.style.backgroundImage = `url('${e.target.result}')`;
                squareContainer.style.backgroundRepeat = 'no-repeat';
                squareContainer.style.backgroundSize = 'cover';

            };

            reader.readAsDataURL(file);
        })
    }

    const file1Input = document.getElementById('rectangle-image-input');
    const rectangleContainer = document.querySelector('.rectangle');

    if (file1Input && rectangleContainer) {
        file1Input.addEventListener('change', function (event) {
            const file = event.target.files[0];
            const reader = new FileReader();

            reader.onload = function (e) {
                rectangleContainer.style.backgroundImage = `url('${e.target.result}')`;
            };

            reader.readAsDataURL(file);
        });
    }

    useEffect(() => {
        if (selectedLogo) {
            const reader = new FileReader();
            reader.readAsDataURL(selectedLogo);
            reader.onloadend = () => {
                const base64String = reader.result;
                setPayload({
                    ...payload,
                    NewLogoImage: base64String,
                    NewLogoImageName: selectedLogo.name
                });
            };
        }
    }, [selectedLogo]);

    useEffect(() => {
        if (selectedCover) {
            const reader = new FileReader();
            reader.readAsDataURL(selectedCover);
            reader.onloadend = () => {
                const base64String = reader.result;
                setPayload({
                    ...payload,
                    NewCoverImage: base64String,
                    NewCoverImageName: selectedCover.name
                });
            };
        }
    }, [selectedCover]);

    return (
        <div className="photos">
            <div className="row">
                <div className="col-4 p-3">
                    <div className="square">
                        <input type="file" className="file-input" accept="image/*"
                               id="square-image-input"
                                onInput={(e) => {
                                    setSelectedLogo(e.target.files[0]);
                                }
                                }
                        />
                        <label htmlFor="square-image-input">Choose an
                            image</label>
                    </div>
                </div>
                <div className="col-8 p-3">
                    <div className="cover photo">
                        <div className="rectangle">
                            <input type="file" className="file-input"
                                   accept="image/*" id="rectangle-image-input"
                                      onInput={(e) => {
                                          setSelectedCover(e.target.files[0]);
                                      }
                                      }
                            />
                            <label htmlFor="rectangle-image-input">Choose an
                                image</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ImagesInput;